import React, {Component} from 'react';
import { StyleSheet, Text, View, ScrollView, Platform, StatusBar, } from 'react-native';
import { BrowserRouter as Router, Switch, Route, Link, Redirect } from 'react-router-dom';
import Routes from './src/native/routes'

class App extends Component {
    constructor(props){
        super(props);        
    }
    
    componentDidMount() {
    }

    render(){
        return(
            <Routes />
        )
    }
}

export default App
